const API = {
  key: '0aede5452ca05333aeb7943df685ad17',
  base: 'https://api.openweathermap.org/data/2.5/',
};

export default API;
